module.exports = __webpack_public_path__ + "img/login_biaoti6.8df11dba.png";